import answers from "./answers";
import Words from "./words";

const API_BASE = process.env.NODE_ENV === 'development' 
  ? 'http://localhost:9999/api'
  : '/api';

function logGuess(date, guess) {
  const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  try {
    fetch(`${API_BASE}/guess`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ date, guess, timezone })
    }).catch(() => {});
  } catch (e) {
    // Fire and forget - don't block on logging errors
  }
}

export async function submitGuess(date, guess) {
  const answer = answers[date];
  
  if (!answer) {
    return { 
      valid: false, 
      error: "no-answer", 
      distance: null,
      isAbove: null,
      distancePercentage: null,
      consecutiveCorrect: null,
      isCorrect: false 
    };
  }
  
  // Fire-and-forget log call
  logGuess(date, guess);
  
  const answerIndex = Words.indexOf(answer);
  const guessIndex = Words.indexOf(guess);
  const distance = Math.abs(guessIndex - answerIndex);
  const isAbove = guessIndex < answerIndex;
  const isCorrect = guess === answer;
  
  let maxDistance;
  if (isAbove) {
    maxDistance = answerIndex;
  } else {
    maxDistance = Words.length - 1 - answerIndex;
  }
  
  let distancePercentage = 0;
  if (maxDistance > 0) {
    const logDistance = Math.log10(distance + 1);
    const logMaxDistance = Math.log10(maxDistance + 1);
    distancePercentage = (logDistance / logMaxDistance) * 100;
  }
  
  let consecutiveCorrect = 0;
  for (let i = 0; i < Math.min(guess.length, answer.length); i++) {
    if (guess[i] === answer[i]) {
      consecutiveCorrect++;
    } else {
      break;
    }
  }
  
  return {
    valid: true,
    error: null,
    distance,
    isAbove,
    distancePercentage,
    consecutiveCorrect,
    isCorrect
  };
}
